import {
	ApiClientManager,
	GetCaptchaOutputDtoSingleOutputMessage,
	XApplicationContextInputDto,
} from '@api/consumerloans-public-api';
import { UseFetchHookOutput, useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useToast } from '@bcp-nextgen-dx-component-factory/design-system';
import { drawers } from '@drawers';
import { useDrawer, useFetch, useGetCurrentBreakpoint, useHideScroll } from '@hooks';
import { useLoadingStore, usePTCMetadata, useServicesStore } from '@store';

export const useFetchGetCaptcha = (): UseFetchHookOutput<
	XApplicationContextInputDto,
	GetCaptchaOutputDtoSingleOutputMessage
> => {
	const saveServiceResponse = useServicesStore((state) => state.saveServiceResponse);
	const metadata = usePTCMetadata();
	const setIsLoadingGetCaptcha = useLoadingStore((state) => state.setIsLoadingGetCaptcha);
	const { hide } = useDrawer('sendEmail');
	const { setToast } = useToast();
	const translate = useTranslation();
	const { enable } = useHideScroll();
	const { currentView } = useGetCurrentBreakpoint();
	const applicationContextId = useServicesStore((state) => state.init?.applicationContextId);

	return useFetch<XApplicationContextInputDto, GetCaptchaOutputDtoSingleOutputMessage>({
		fetchFn: (data: XApplicationContextInputDto) =>
			ApiClientManager.call.getCaptcha({
				data: { ...data, metadata, applicationContextId },
			}),
		onSuccess: (res: GetCaptchaOutputDtoSingleOutputMessage) => {
			if (res.data) {
				setIsLoadingGetCaptcha(false);
				saveServiceResponse({ getCaptcha: res.data || {} });
			}
		},
		onError: () => {
			setIsLoadingGetCaptcha(false);
			hide();
			enable();
			const checkerNull = document.getElementById('mainMenu');
			if (checkerNull !== null) {
				checkerNull.style.zIndex = '1';
			}
			setToast('visible', {
				feedbackStatus: 'error',
				title: translate('simulator.couldntSendEmailDueToCaptcha'),
				progressBar: true,
				dismissTimer: 3000,
				placement: { vertical: currentView === 'smallView' ? 'top' : 'bottom' },
				actionButtonProps: undefined,
				containerStyles: { zIndex: 9999 },
				onHide: () => {
					const checkerNull = document.getElementById('mainMenu');
					if (checkerNull !== null) {
						checkerNull.style.zIndex = '500';
					}
				},
			});
		},
		notShowLoading: true,
	});
};
